const COVERS = [
  {
    img: "https://readdy.ai/api/search-image?query=editorial%20magazine%20cover%20with%20dramatic%20red%20light%20and%20ink%20black%20on%20cream%20paper%2C%20shadowed%20silhouette%20figure%2C%20bold%20typography%20blocks%2C%20vintage%20print%20texture%2C%20news%20magazine%20art%20direction%2C%20high%20contrast%20minimal&width=500&height=660&seq=cover-portrait-09&orientation=portrait"
    ,
    label: "领跑者逆风者的「翻盘」封面",
  },
  {
    img: "https://readdy.ai/api/search-image?query=dark%20layered%20deep%20water%20with%20cream%20mist%20magazine%20cover%2C%20mysterious%20editorial%20art%2C%20hidden%20documents%20shadow%2C%20subtle%20red%20glow%2C%20vintage%20print%20texture%2C%20artistic%20news%20graphic&width=500&height=660&seq=cover-deep-10&orientation=portrait"
    ,
    label: "深水区的「旧账底稿」特辑",
  },
  {
    img: "https://readdy.ai/api/search-image?query=concentric%20echo%20rings%20on%20cream%20paper%20magazine%20cover%2C%20editorial%20abstract%20graphic%2C%20old%20recording%20tape%20motif%2C%20ink%20and%20warm%20red%20palette%2C%20vintage%20print%20texture%2C%20minimal%20art%20direction&width=500&height=660&seq=cover-echo-11&orientation=portrait"
    ,
    label: "回声室单周跳升九位封面",
  },
  {
    img: "https://readdy.ai/api/search-image?query=sharp%20breaking%20horizon%20line%20with%20light%20magazine%20cover%2C%20comeback%20concept%20editorial%20art%2C%20cream%20background%20ink%20shadow%2C%20bold%20red%20typography%20mark%2C%20vintage%20print%20texture%2C%20minimal%20graphic%20composition&width=500&height=660&seq=cover-line-12&orientation=portrait"
    ,
    label: "临界点回归：断了三个月的线",
  },
];

export default function CoverGallery() {
  return (
    <section id="cover" className="border-t border-[#e4d9c6] bg-[#f6f0e6]">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="text-xs font-semibold tracking-[0.25em] text-[#b03a2e] uppercase">
              Cover Archive
            </p>
            <h2 className="font-display mt-2 text-2xl font-black text-[#18130e] md:text-4xl">
              焦点封面 · 谁的版面在说话
            </h2>
          </div>
          <a
            href="#nomi"
            className="flex items-center gap-1 whitespace-nowrap text-sm font-semibold text-[#8f2a20] hover:text-[#b03a2e]"
          >
            全部候选封面 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-4 md:gap-5 lg:grid-cols-4">
          {COVERS.map((c) => (
            <a
              key={c.label}
              href="#feed"
              className="group relative block overflow-hidden rounded-xl border border-[#e4d9c6]"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img
                  src={c.img}
                  alt={`黑料王焦点封面 ${c.label}`}
                  title={`黑料王封面图集 ${c.label}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#18130e]/85 via-[#18130e]/30 to-transparent p-4 pt-10">
                <p className="text-[13px] font-semibold leading-snug text-[#fbf7ef]">
                  {c.label}
                </p>
                <span className="mt-1 block text-[11px] text-[#e6c9a8]">翻页细读 →</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}